import React from "react";
import Logo from "@/components/Logo";
import { Mail, Phone, Linkedin, ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/5 bg-[#040806] pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 pb-12 border-b border-white/5">
          <div className="lg:col-span-5">
            <Logo />
            <p className="mt-6 text-gray-400 max-w-sm leading-relaxed">
              Des racines solides pour une sécurité sans faille.
              <br />
              <span className="italic">La cybersécurité aux racines profondes.</span>
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a
                href="mailto:contact@baobsec.com"
                data-testid="footer-email"
                className="p-3 rounded-xl border border-[#1A2E22] hover:border-emerald-500/40 hover:text-emerald-400 text-gray-400 transition-colors"
                aria-label="Email"
              >
                <Mail className="w-4 h-4" />
              </a>
              <a
                href="tel:+33652353418"
                data-testid="footer-phone"
                className="p-3 rounded-xl border border-[#1A2E22] hover:border-emerald-500/40 hover:text-emerald-400 text-gray-400 transition-colors"
                aria-label="Téléphone"
              >
                <Phone className="w-4 h-4" />
              </a>
              <a
                href="https://www.linkedin.com/company/baobsec"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin"
                className="p-3 rounded-xl border border-[#1A2E22] hover:border-emerald-500/40 hover:text-emerald-400 text-gray-400 transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="text-xs font-mono text-emerald-400 mb-4 tracking-widest">
              // SERVICES
            </div>
            <ul className="space-y-3 text-sm text-gray-400">
              <li><a href="#services" className="hover:text-emerald-400 transition-colors">Gouvernance</a></li>
              <li><a href="#services" className="hover:text-emerald-400 transition-colors">ISO 27001</a></li>
              <li><a href="#services" className="hover:text-emerald-400 transition-colors">SOC & SIEM</a></li>
              <li><a href="#services" className="hover:text-emerald-400 transition-colors">Réponse incident</a></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="text-xs font-mono text-emerald-400 mb-4 tracking-widest">
              // COMPANY
            </div>
            <ul className="space-y-3 text-sm text-gray-400">
              <li><a href="#approche" className="hover:text-emerald-400 transition-colors">Approche</a></li>
              <li><a href="#standards" className="hover:text-emerald-400 transition-colors">Standards</a></li>
              <li><a href="#temoignages" className="hover:text-emerald-400 transition-colors">Témoignages</a></li>
              <li><a href="#contact" className="hover:text-emerald-400 transition-colors">Contact</a></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="text-xs font-mono text-emerald-400 mb-4 tracking-widest">
              // CONTACT
            </div>
            <ul className="space-y-3 text-sm text-gray-400">
              <li>
                <a
                  href="mailto:contact@baobsec.com"
                  className="hover:text-emerald-400 transition-colors inline-flex items-center gap-1"
                >
                  contact@baobsec.com
                  <ArrowUpRight className="w-3 h-3" />
                </a>
              </li>
              <li>
                <a
                  href="tel:+33652353418"
                  className="hover:text-emerald-400 transition-colors"
                >
                  +33 6 52 35 34 18
                </a>
              </li>
              <li>France 🇫🇷 · Sénégal 🇸🇳</li>
              <li className="text-[11px] text-gray-600">Remote · Afrique de l'Ouest & Europe</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-500 font-mono">
            © {new Date().getFullYear()} BAOBSEC · Tous droits réservés.
          </p>
          <p className="text-xs text-gray-600 font-mono">
            CRAFTED WITH <span className="text-emerald-500">▸</span> ROOTS DEEP IN SECURITY
          </p>
        </div>
      </div>
    </footer>
  );
}
